import React, { Component } from 'react';
import { connect } from 'react-redux';
import Captcha from '../../fm/lib/Captcha'
import {sendForm} from '../../fm/reducers/page'

const strings = {
		name: 'Numele Dvs.',
		email: 'E-mail',
		phone: 'Telefon',
		message: 'Mesaj',
		send: 'Trimite',
		sending: 'Se trimite mesajul...',
		formSent: '<p>Mesajul Dvs a fost trimis. <br/>În cel mai scurt timp un reprezentant al Şcolii va lua legătura cu Dvs.</p>'
}

class Contact extends Component {
	state = {
		name: '',
		email: '',
		phone: '',
		captcha: '',
		text: '',
		formState: 0
	}
	componentWillReceiveProps(nextProps) {
		const { sendingForm } = nextProps
		const { formState } = this.state
		
		if (!sendingForm && formState===1) this.setState({formState: 2})
	}
	onTextChange(field, e) {
		this.setState({[field]: e.target.value})
	}
	onCaptchaChange(value) {
		this.setState({captcha: value})
	}
	
	onSend() {
		const {name, email, phone, text, captcha} = this.state
        const {sendForm} = this.props

        if(name==='' || email==='' || phone==='' || text==='') return

		this.setState({formState: 1})
        sendForm({form: 'contact', name, email, text, captcha})

	}
	render() {
		const { menu, config} = this.props
		const { formState } = this.state

		window.recaptchaOptions = {
  			lang: 'ro'
		}
		
		if (formState === 1) {
			return <div className='contact form'><h3 className='status sending'><i className="fa fa-spinner fa-pulse fa-fw"></i> {strings.sending}</h3></div>
		}
		if (formState === 2) {
			return <div className='contact form'><h3 className='status sent'><i className='fa fa-check fa-2x'></i> <div dangerouslySetInnerHTML={{__html: strings.formSent}}/></h3></div>
		}
		
		return (
		<div id={config.id}
		className={config.classes.join(' ')}
		style={config.style}>
		{menu}
		<div className='block-in'>
			<h1 className='form-title'>Ne puteţi scrie...</h1>
			<div className='contact form'>
				<input type='text' placeholder={strings.name} value={this.state.name} onChange={this.onTextChange.bind(this, 'name')}/>
				<input type='text' placeholder={strings.email}  value={this.state.email} onChange={this.onTextChange.bind(this, 'email')}/>
				<input type='text' placeholder={strings.phone}  value={this.state.phone} onChange={this.onTextChange.bind(this, 'phone')}/>
				<textarea type='text' placeholder={strings.message}  value={this.state.text} onChange={this.onTextChange.bind(this, 'text')}/>
				<Captcha onChange={value => this.onCaptchaChange(value)} />
				<a className='button blue' onClick={this.onSend.bind(this)}>{strings.send}</a>
			</div>
		</div></div>
		)
  	}
}

function mapStateToProps(state, ownProps) {
	return {
		sendingForm: state.page.sendingForm
	}
}
export default connect(mapStateToProps, {sendForm})(Contact);



// WEBPACK FOOTER //
// ./src/components/block/Contact.js